@if (!loading()) {
  <img [src]="iconPath()" class="gateway-icon icon-{{ variant() }}" alt="" />
  @if (nbBoxes() > 1) {
    <span class="additional-boxes-count">+{{ nbBoxes() - 1 }}</span>
  }
}
